export enum SIGN_IN_TYPE {
  OFFCHAIN = "OFFCHAIN",
  ONCHAIN = "ONCHAIN",
}
